<div class="drawer-container">
    <div
        [@iccDrawerAnimation]="drawerAnimationState"
        class="drawer"
        #drawer
    >
        <icc-complaint-v1-filters
            [filters]="filters"
            (filtersEmitter)="setFilters($event)"
            [hasContractorFilter]="hasAccessTo.manageComplaint"
        ></icc-complaint-v1-filters>

    </div>
    <div class="container">
        <div class="actions">
            <div class="actions-left">
                <button
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
            </div>
            <div class="actions-right">
                <button class="action-button-refresh" iccIconButton appearance="flat-base" (click)="updateList(true)" [title]="'INTERFACE|Odśwież' | translate">
                    <icc-icon name="replay"></icc-icon>
                </button>
            </div>
        </div>

        <div class="table-container">
            <table class="documents-table">
                <thead>
                    <tr>
                        <th><span translate>COMPLAINT|Zgłoszenie</span></th>
                        <th><span translate>COMPLAINT|Zamówienie</span></th>
                        <th  *ngIf="hasAccessTo.manageComplaint"><span translate>COMPLAINT|Zgłaszający</span></th>
                        <th><span translate>COMPLAINT|Status</span></th>
                        <th translate *ngIf="!mobileView">INTERFACE|Opcje</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let document of allComplaints  | paginate: { itemsPerPage: documentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
                        <tr>
                            <td class="documents-table__name" (click)="open(document)">
                                <span>{{ document?.documentNumber?.join ? document?.documentNumber?.join('') : '' }}</span><br>
                                {{ document?.created | date : 'medium' }}
                            </td>
                            <td class="documents-table__order" (click)="open(document)">
                                <span>{{ document?.orderDocumentNumber?.join ? document?.orderDocumentNumber?.join('') : '' }}</span><br>
                                <span>{{ document?.orderPositionTitle?.length ? document?.orderPositionTitle.join('/') : ''  }}</span>
                            </td>
                            <td class="documents-table__client" (click)="open(document)" *ngIf="hasAccessTo.manageComplaint">
                                <ng-container *ngIf="document.contractorCompanyName" >
                                    {{ document.contractorCompanyName }}<br>
                                </ng-container>
                                <ng-container *ngIf="document.contractorName" >
                                    {{ document.contractorName }}<br>
                                </ng-container>
                            </td>
                            <td class="documents-table__status" (click)="open(document)">
                                <icc-complaint-v1-status [status]="document.status"></icc-complaint-v1-status>
                            </td>
                            <td *ngIf="!mobileView">
                                <div class="documents-table__options">
                                    <button iccButton appearance="secondary"  (click)="open(document)">
                                        {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
        ></pagination-controls>
    </div>
</div>